import {
    BlueskyShareButton,
    FacebookMessengerShareButton,
    WeiboShareButton,
    // XShareButton,
    EmailShareButton,
    FacebookShareButton,
    // GabShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    ThreadsShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton,
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    // GabIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    ThreadsIcon,
    TumblrIcon,
    // TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon,
    XIcon,
    BlueskyIcon,
  } from "react-share";

const iconsSpecs = [
    {
      lowercase: "email",
      button: EmailShareButton,
      icon: EmailIcon,
      name: "Email"
    },
    // {
    //   lowercase: "pinterest",
    //   button: PinterestShareButton,
    //   icon: PinterestIcon,
    //   name: "Pinterest"
    // },
    {
      lowercase: "facebook",
      button: FacebookShareButton,
      icon: FacebookIcon,
      name: "Facebook"
    },
    {
      lowercase: "reddit",
      button: RedditShareButton,
      icon: RedditIcon,
      name: "Reddit"
    },
    {
      lowercase: "tumblr",
      button: TumblrShareButton,
      icon: TumblrIcon,
      name: "Tumblr"
    },
    // {
    //   lowercase: "facebookmessenger",
    //   button: FacebookMessengerShareButton,
    //   icon: FacebookMessengerIcon,
    //   name: "FacebookMessenger"
    // },
    {
      lowercase: "whatsapp",
      button: WhatsappShareButton,
      icon: WhatsappIcon,
      name: "Whatsapp"
    },
    {
      lowercase: "linkedin",
      button: LinkedinShareButton,
      icon: LinkedinIcon,
      name: "Linkedin"
    },
    {
      lowercase: "telegram",
      button: TelegramShareButton,
      icon: TelegramIcon,
      name: "Telegram"
    },
    {
      lowercase: "x",
      button: TwitterShareButton,
      icon: XIcon,
      name: "X"
    },
    {
      lowercase: "threads",
      button: ThreadsShareButton,
      icon: ThreadsIcon,
      name: "Threads"
    },
    {
      lowercase: "line",
      button: LineShareButton,
      icon: LineIcon,
      name: "Line"
    },
    {
      lowercase: "viber",
      button: ViberShareButton,
      icon: ViberIcon,
      name: "Viber"
    },
    {
      lowercase: "vk",
      button: VKShareButton,
      icon: VKIcon,
      name: "VK"
    },
    {
      lowercase: "ok",
      button: OKShareButton,
      icon: OKIcon,
      name: "OK"
    },
    {
      lowercase: "mailru",
      button: MailruShareButton,
      icon: MailruIcon,
      name: "Mailru"
    },
    {
      lowercase: "weibo",
      button: WeiboShareButton,
      icon: WeiboIcon,
      name: "Weibo"
    },
    {
      lowercase: "instapaper",
      button: InstapaperShareButton,
      icon: InstapaperIcon,
      name: "Instapaper"
    },
    {
      lowercase: "pocket",
      button: PocketShareButton,
      icon: PocketIcon,
      name: "Pocket"
    },
    {
      lowercase: "livejournal",
      button: LivejournalShareButton,
      icon: LivejournalIcon,
      name: "Livejournal"
    },
    {
      lowercase: "workplace",
      button: WorkplaceShareButton,
      icon: WorkplaceIcon,
      name: "Workplace"
    },
    {
      lowercase: "hatena",
      button: HatenaShareButton,
      icon: HatenaIcon,
      name: "Hatena"
    },
    {
      lowercase: "bluesky",
      button: BlueskyShareButton,
      icon: BlueskyIcon,
      name: "Bluesky"
    }
  ]

export default iconsSpecs;